export const PAYMENT_RECEIPT_DOCUMENT_ID = "000000115";

export const ONLINE_PAYMENT_API_URL =
  "https://pay.inpsycho.ru/api/fd388787f566a04a1065795e13b47fd6.php";
